export default __webpack_public_path__ + "static/media/coffee-time.587b43c8.svg";